export default __webpack_public_path__ + "static/media/tradingview_strategy.bd884adc.png";